import { matchPath, useLocation } from 'react-router';
import { match } from 'ts-pattern';
import { useStringUrlSearchParam } from '../utils/url-search-params/use-query-url-search-params';
import UrlSearchParamKey from '../utils/url-search-params/url-search-params';
import { Page, PageUrlPath } from '../app/page-url-path';
import { useGetRouteToIssuerPage } from '../app/get-route-to-page';
import { convertRelativeToAbsolutePath } from '../app/router-utils';

export const usePostLoginRedirectDestination = () => {
  const location = useLocation();
  const currentPageIsLoginPage = !!matchPath(location.pathname, {
    path: [PageUrlPath[Page.LOGIN_PAGE]],
    strict: false,
    exact: false,
  });

  const maybePostLoginRedirectFromParams = useStringUrlSearchParam(
    UrlSearchParamKey.REDIRECT_TO,
  );
  const homepageRelativeUrl = useGetRouteToIssuerPage(Page.HOMEPAGE);
  const homepageUrlWithDomain =
    convertRelativeToAbsolutePath(homepageRelativeUrl);

  const getPostLoginRedirectDestination = (
    isUrlWithDomain: boolean,
    shouldRedirectToCurrentPageAfterLogin = true,
  ) => {
    const homepageUrl = isUrlWithDomain
      ? homepageUrlWithDomain
      : homepageRelativeUrl;
    const redirectDestination = match({
      currentPageIsLoginPage,
      shouldRedirectToCurrentPageAfterLogin,
    })
      .with(
        { currentPageIsLoginPage: true },
        () =>
          // If we are on the login page, we never want to redirect to the current URL after logging
          // in, even if shouldRedirectToCurrentPageAfterLogin is true.
          maybePostLoginRedirectFromParams ?? homepageUrl,
      )
      .with(
        { shouldRedirectToCurrentPageAfterLogin: true },
        () => window.location.href,
      )
      .otherwise(() => homepageUrl);
    return redirectDestination;
  };

  return { getPostLoginRedirectDestination };
};
